import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Check, 
  ArrowRight, 
  ChevronDown, 
  ChevronUp, 
  ShoppingBag, 
  Award, 
  Clock, 
  Users,
  Plus,
  Minus
} from 'lucide-react';
import PublicNavbar from '@/Components/layout/PublicNavbar';
import PublicFooter from '@/Components/layout/PublicFooter';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Pricing() {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    { q: "Berapa MOQ minimum untuk maklon di Satala Dermatech?", a: "MOQ minimum kami dimulai dari 1.000 pcs untuk paket Starter." },
    { q: "Apakah harga sudah termasuk registrasi BPOM?", a: "Ya, sebagian besar paket kami sudah mencakup biaya registrasi BPOM." },
    { q: "Apakah saya bisa menggunakan formula sendiri?", a: "Tentu, untuk paket Growth ke atas kami memfasilitasi penggunaan atau penyesuaian formula khusus (Custom Formula)." },
    { q: "Apakah bisa custom kemasan sesuai branding saya?", a: "Sangat bisa. Kami menyediakan berbagai pilihan packaging yang dapat disesuaikan." },
    { q: "Berapa lama proses produksi hingga produk siap jual?", a: "Estimasi waktu bervariasi antara 2 hingga 3 bulan tergantung kompleksitas dan antrean BPOM." },
    { q: "Apakah tersedia sertifikasi Halal?", a: "Ya, kami dapat membantu pengurusan sertifikasi Halal untuk produk Anda." }
  ];

  return (
    <div className="min-h-screen bg-[#FDFBF7] font-sans text-[#302621]">
      <PublicNavbar />

      {/* HERO SECTION */}
      <section className="relative pt-24 pb-16 lg:pt-32 lg:pb-24 overflow-hidden">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-[#F3EFEA] rounded-bl-[100px] -z-10 hidden lg:block"></div>
        <div className="container mx-auto px-6 lg:px-12 relative z-10">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-1/2">
              <span className="text-[#C19B6C] font-bold tracking-wider text-sm mb-4 block uppercase">Paket Maklon Skincare</span>
              <h1 className="text-4xl lg:text-5xl font-extrabold leading-tight mb-6">
                Pilih Paket Maklon yang Sesuai dengan Tahap Pertumbuhan Brand Anda
              </h1>
              <p className="text-lg text-gray-600 mb-8 max-w-xl">
                Mulai dari brand yang baru merintis hingga perusahaan yang ingin mengembangkan produk premium berskala besar, kami menyediakan solusi maklon yang fleksibel dan terukur.
              </p>
              <div className="flex flex-wrap items-center gap-4">
                <button className="bg-[#C19B6C] hover:bg-[#A8865A] text-white px-8 py-3 rounded font-semibold transition-colors flex items-center gap-2">
                  Konsultasi Gratis <ArrowRight className="w-4 h-4" />
                </button>
                <button className="bg-white border border-[#C19B6C] text-[#C19B6C] hover:bg-gray-50 px-8 py-3 rounded font-semibold transition-colors">
                  Lihat Paket
                </button>
              </div>
            </div>
            <div className="lg:w-1/2">
              {/* Replace with actual image */}
              <div className="relative w-full aspect-square md:aspect-video lg:aspect-square bg-[#F3EFEA] rounded-2xl overflow-hidden flex items-center justify-center">
                 <img src="/placeholder-hero.jpg" alt="Skincare Products" className="w-full h-full object-cover" onError={(e) => e.target.src = 'https://images.unsplash.com/photo-1629198688000-71f23e745b6e?q=80&w=800&auto=format&fit=crop'} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="py-8 bg-white border-y border-gray-100">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-gray-100">
            <div className="flex items-center gap-4 px-4">
              <div className="w-12 h-12 bg-[#FDFBF7] rounded-full flex items-center justify-center text-[#C19B6C]">
                <ShoppingBag className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-2xl font-bold">150+</h3>
                <p className="text-sm text-gray-500">Brand Bermitra</p>
              </div>
            </div>
            <div className="flex items-center gap-4 px-4">
              <div className="w-12 h-12 bg-[#FDFBF7] rounded-full flex items-center justify-center text-[#C19B6C]">
                <Award className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-2xl font-bold">750+</h3>
                <p className="text-sm text-gray-500">Produk Diproduksi</p>
              </div>
            </div>
            <div className="flex items-center gap-4 px-4">
              <div className="w-12 h-12 bg-[#FDFBF7] rounded-full flex items-center justify-center text-[#C19B6C]">
                <Clock className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-2xl font-bold">10+</h3>
                <p className="text-sm text-gray-500">Tahun Pengalaman</p>
              </div>
            </div>
            <div className="flex items-center gap-4 px-4">
              <div className="w-12 h-12 bg-[#FDFBF7] rounded-full flex items-center justify-center text-[#C19B6C]">
                <Users className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-2xl font-bold">95%</h3>
                <p className="text-sm text-gray-500">Repeat Client</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING CARDS */}
      <section className="py-20 bg-[#FDFBF7]">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <span className="text-[#C19B6C] font-bold tracking-wider text-sm mb-2 block uppercase">Paket Maklon Kami</span>
            <h2 className="text-3xl lg:text-4xl font-extrabold mb-4">Pilih Paket yang Tepat untuk Brand Anda</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">Setiap paket dirancang untuk memenuhi kebutuhan bisnis yang berbeda, mulai dari startup hingga enterprise.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Starter */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 flex flex-col hover:shadow-lg transition-shadow">
              <span className="bg-[#F3EFEA] text-[#C19B6C] text-xs font-bold px-3 py-1 rounded-full self-start mb-4">Untuk Brand Baru</span>
              <h3 className="text-2xl font-bold mb-2">STARTER</h3>
              <p className="text-sm text-gray-500 mb-4">Mulai</p>
              <div className="text-3xl font-extrabold mb-2">Rp 15 Juta</div>
              <p className="text-sm font-semibold mb-6">MOQ<br/>1.000 pcs</p>
              <ul className="space-y-3 mb-8 flex-1">
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Formula Standar Skincare</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Registrasi BPOM</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Produksi</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Quality Control</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Konsultasi Produk</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Packaging Standard</li>
              </ul>
              <button className="w-full border border-[#C19B6C] text-[#C19B6C] hover:bg-[#FDFBF7] py-3 rounded font-semibold transition-colors">
                Pilih Paket
              </button>
            </div>

            {/* Growth */}
            <div className="bg-white border-2 border-[#C19B6C] rounded-xl p-8 flex flex-col shadow-xl relative transform lg:-translate-y-4">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#C19B6C] text-white text-xs font-bold px-4 py-1 rounded-full">
                PALING POPULER
              </div>
              <h3 className="text-2xl font-bold mb-2 mt-2">GROWTH</h3>
              <p className="text-sm text-gray-500 mb-4">Mulai</p>
              <div className="text-3xl font-extrabold mb-2">Rp 35 Juta</div>
              <p className="text-sm font-semibold mb-6">MOQ<br/>3.000 pcs</p>
              <ul className="space-y-3 mb-8 flex-1">
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Formula Premium (Bahan Aktif)</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> BPOM Support</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Sampling</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Desain Kemasan</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Quality Control</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Produksi</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Pendampingan Brand</li>
              </ul>
              <button className="w-full bg-[#C19B6C] hover:bg-[#A8865A] text-white py-3 rounded font-semibold transition-colors">
                Pilih Paket
              </button>
            </div>

            {/* Premium */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 flex flex-col hover:shadow-lg transition-shadow">
              <h3 className="text-2xl font-bold mb-2 mt-6">PREMIUM</h3>
              <p className="text-sm text-gray-500 mb-4">Mulai</p>
              <div className="text-3xl font-extrabold mb-2">Rp 75 Juta</div>
              <p className="text-sm font-semibold mb-6">MOQ<br/>5.000 pcs+</p>
              <ul className="space-y-3 mb-8 flex-1">
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Custom Formula (R&D Khusus)</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Full Custom Racikan</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> BPOM</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Sertifikasi Halal</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Premium Packaging</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Dedicated Consultant</li>
                <li className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#C19B6C]" /> Priority Production</li>
              </ul>
              <button className="w-full border border-[#C19B6C] text-[#C19B6C] hover:bg-[#FDFBF7] py-3 rounded font-semibold transition-colors">
                Diskusikan Proyek
              </button>
            </div>

            {/* Enterprise */}
            <div className="bg-[#1A1A1A] text-white border border-[#333] rounded-xl p-8 flex flex-col shadow-xl">
              <h3 className="text-2xl font-bold mb-2 mt-6">ENTERPRISE</h3>
              <p className="text-sm text-gray-400 mb-4">Custom</p>
              <div className="text-3xl font-extrabold text-[#C19B6C] mb-2">Quotation</div>
              <p className="text-sm font-semibold mb-6 text-gray-300">MOQ<br/>10.000 pcs+</p>
              <ul className="space-y-3 mb-8 flex-1">
                <li className="flex items-center gap-2 text-sm text-gray-300"><Check className="w-4 h-4 text-[#C19B6C]" /> Multi Product Development</li>
                <li className="flex items-center gap-2 text-sm text-gray-300"><Check className="w-4 h-4 text-[#C19B6C]" /> Dedicated Team</li>
                <li className="flex items-center gap-2 text-sm text-gray-300"><Check className="w-4 h-4 text-[#C19B6C]" /> Private Manufacturing</li>
                <li className="flex items-center gap-2 text-sm text-gray-300"><Check className="w-4 h-4 text-[#C19B6C]" /> NDA Agreement</li>
                <li className="flex items-center gap-2 text-sm text-gray-300"><Check className="w-4 h-4 text-[#C19B6C]" /> Export Preparation</li>
                <li className="flex items-center gap-2 text-sm text-gray-300"><Check className="w-4 h-4 text-[#C19B6C]" /> Full Project Management</li>
              </ul>
              <button className="w-full bg-[#C19B6C] hover:bg-[#A8865A] text-white py-3 rounded font-semibold transition-colors">
                Hubungi Tim Kami
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* COMPARISON TABLE */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6 lg:px-12 overflow-x-auto">
          <div className="mb-10">
            <span className="text-[#C19B6C] font-bold tracking-wider text-sm mb-2 block uppercase">Perbandingan Paket</span>
            <h2 className="text-3xl font-extrabold">Bandingkan Paket Maklon</h2>
          </div>
          
          <table className="w-full min-w-[800px] text-left border-collapse">
            <thead>
              <tr className="border-b-2 border-[#C19B6C]">
                <th className="py-4 px-4 font-bold w-1/3">Fitur</th>
                <th className="py-4 px-4 font-bold text-center">Starter</th>
                <th className="py-4 px-4 font-bold text-center">Growth</th>
                <th className="py-4 px-4 font-bold text-center">Premium</th>
                <th className="py-4 px-4 font-bold text-center">Enterprise</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {[
                { name: "Formula Standar", s: true, g: true, p: true, e: true },
                { name: "Formula Premium (Bahan Aktif)", s: false, g: true, p: true, e: true },
                { name: "Custom Formula (R&D Khusus)", s: false, g: false, p: true, e: true },
                { name: "Uji Klinis & Dermatologi", s: false, g: false, p: true, e: true },
                { name: "Registrasi BPOM", s: true, g: true, p: true, e: true },
                { name: "Sertifikasi Halal", s: false, g: "Optional", p: true, e: true },
                { name: "Desain Kemasan", s: false, g: true, p: true, e: true },
                { name: "Dedicated Consultant", s: false, g: false, p: true, e: true },
                { name: "Priority Production", s: false, g: false, p: true, e: true },
                { name: "MOQ Minimum", s: "1.000 pcs", g: "3.000 pcs", p: "5.000 pcs+", e: "10.000 pcs+" },
                { name: "Pendampingan Brand", s: false, g: true, p: true, e: true },
                { name: "Private Manufacturing", s: false, g: false, p: false, e: true },
              ].map((row, idx) => (
                <tr key={idx} className="hover:bg-gray-50">
                  <td className="py-4 px-4 text-sm font-medium">{row.name}</td>
                  <td className="py-4 px-4 text-center">
                    {row.s === true ? <Check className="w-5 h-5 text-[#C19B6C] mx-auto"/> : row.s === false ? <span className="text-gray-300">-</span> : <span className="text-sm">{row.s}</span>}
                  </td>
                  <td className="py-4 px-4 text-center">
                    {row.g === true ? <Check className="w-5 h-5 text-[#C19B6C] mx-auto"/> : row.g === false ? <span className="text-gray-300">-</span> : <span className="text-sm">{row.g}</span>}
                  </td>
                  <td className="py-4 px-4 text-center">
                    {row.p === true ? <Check className="w-5 h-5 text-[#C19B6C] mx-auto"/> : row.p === false ? <span className="text-gray-300">-</span> : <span className="text-sm">{row.p}</span>}
                  </td>
                  <td className="py-4 px-4 text-center">
                    {row.e === true ? <Check className="w-5 h-5 text-[#C19B6C] mx-auto"/> : row.e === false ? <span className="text-gray-300">-</span> : <span className="text-sm">{row.e}</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* CALCULATOR & PROPOSAL */}
      <section className="py-16 bg-[#FDFBF7]">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            
            {/* Left: Calculator */}
            <div className="bg-white border border-gray-100 rounded-2xl p-8 shadow-sm">
              <h3 className="text-2xl font-bold mb-2">Hitung Estimasi Investasi Anda</h3>
              <p className="text-sm text-gray-500 mb-8">Dapatkan perkiraan biaya sesuai kebutuhan produk brand Anda.</p>
              
              <div className="space-y-4 mb-8">
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Jenis Produk</label>
                  <Select defaultValue="Skincare">
                    <SelectTrigger className="w-full border-gray-200 focus:ring-[#C19B6C] focus:border-[#C19B6C] h-[46px] bg-white text-sm">
                      <SelectValue placeholder="Pilih Jenis" />
                    </SelectTrigger>
                    <SelectContent className="bg-white border border-[#E8DCC8] shadow-2xl rounded-xl z-50 overflow-hidden">
                      <SelectItem value="Skincare" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">Skincare</SelectItem>
                      <SelectItem value="Bodycare" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">Bodycare</SelectItem>
                      <SelectItem value="Haircare" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">Haircare</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">MOQ</label>
                  <Select defaultValue="3.000 pcs">
                    <SelectTrigger className="w-full border-gray-200 focus:ring-[#C19B6C] focus:border-[#C19B6C] h-[46px] bg-white text-sm">
                      <SelectValue placeholder="Pilih MOQ" />
                    </SelectTrigger>
                    <SelectContent className="bg-white border border-[#E8DCC8] shadow-2xl rounded-xl z-50 overflow-hidden">
                      <SelectItem value="1.000 pcs" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">1.000 pcs</SelectItem>
                      <SelectItem value="3.000 pcs" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">3.000 pcs</SelectItem>
                      <SelectItem value="5.000 pcs" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">5.000 pcs</SelectItem>
                      <SelectItem value="10.000 pcs+" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">10.000 pcs+</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Grade Bibit</label>
                  <Select defaultValue="B (Premium)">
                    <SelectTrigger className="w-full border-gray-200 focus:ring-[#C19B6C] focus:border-[#C19B6C] h-[46px] bg-white text-sm">
                      <SelectValue placeholder="Pilih Grade" />
                    </SelectTrigger>
                    <SelectContent className="bg-white border border-[#E8DCC8] shadow-2xl rounded-xl z-50 overflow-hidden">
                      <SelectItem value="A (Exclusive)" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">A (Exclusive)</SelectItem>
                      <SelectItem value="B (Premium)" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">B (Premium)</SelectItem>
                      <SelectItem value="C (Deluxe)" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">C (Deluxe)</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Kemasan</label>
                  <Select defaultValue="Standard">
                    <SelectTrigger className="w-full border-gray-200 focus:ring-[#C19B6C] focus:border-[#C19B6C] h-[46px] bg-white text-sm">
                      <SelectValue placeholder="Pilih Kemasan" />
                    </SelectTrigger>
                    <SelectContent className="bg-white border border-[#E8DCC8] shadow-2xl rounded-xl z-50 overflow-hidden">
                      <SelectItem value="Standard" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">Standard</SelectItem>
                      <SelectItem value="Premium" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">Premium</SelectItem>
                      <SelectItem value="Exclusive" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">Exclusive</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>

              <div className="bg-[#FDFBF7] border border-[#E8DCC8] rounded-xl p-6 text-center">
                <p className="text-sm text-gray-600 mb-2">Estimasi Investasi</p>
                <div className="text-2xl font-extrabold text-[#302621] mb-2">Rp 25.000.000 - Rp 40.000.000</div>
                <p className="text-xs text-gray-500 mb-4">Rekomendasi Paket</p>
                <div className="text-lg font-bold text-[#C19B6C] mb-6">Growth Package</div>
                <button className="w-full bg-[#C19B6C] hover:bg-[#A8865A] text-white py-3 rounded font-semibold transition-colors">
                  Minta Proposal Lengkap
                </button>
              </div>
            </div>

            {/* Right: Proposal Form */}
            <div className="bg-white border border-gray-100 rounded-2xl p-8 shadow-sm">
              <h3 className="text-2xl font-bold mb-2">Dapatkan Proposal & Penawaran</h3>
              <p className="text-sm text-gray-500 mb-8">Isi formulir berikut dan tim kami akan menghubungi Anda untuk memberikan proposal terbaik.</p>
              
              <form className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Nama Lengkap *</label>
                    <input type="text" className="w-full border border-gray-200 rounded p-3 text-sm focus:ring-[#C19B6C] focus:border-[#C19B6C]" placeholder="Nama Lengkap" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Nama Brand *</label>
                    <input type="text" className="w-full border border-gray-200 rounded p-3 text-sm focus:ring-[#C19B6C] focus:border-[#C19B6C]" placeholder="Nama Brand" />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">WhatsApp *</label>
                    <input type="text" className="w-full border border-gray-200 rounded p-3 text-sm focus:ring-[#C19B6C] focus:border-[#C19B6C]" placeholder="08..." />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Email *</label>
                    <input type="email" className="w-full border border-gray-200 rounded p-3 text-sm focus:ring-[#C19B6C] focus:border-[#C19B6C]" placeholder="email@contoh.com" />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Jenis Produk *</label>
                    <Select>
                      <SelectTrigger className="w-full border-gray-200 focus:ring-[#C19B6C] focus:border-[#C19B6C] h-[46px] bg-white text-sm">
                        <SelectValue placeholder="Pilih Jenis" />
                      </SelectTrigger>
                      <SelectContent className="bg-white border border-[#E8DCC8] shadow-2xl rounded-xl z-50 overflow-hidden">
                        <SelectItem value="Skincare" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">Skincare</SelectItem>
                        <SelectItem value="Bodycare" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">Bodycare</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Paket yang Diminati *</label>
                    <Select>
                      <SelectTrigger className="w-full border-gray-200 focus:ring-[#C19B6C] focus:border-[#C19B6C] h-[46px] bg-white text-sm">
                        <SelectValue placeholder="Pilih Paket" />
                      </SelectTrigger>
                      <SelectContent className="bg-white border border-[#E8DCC8] shadow-2xl rounded-xl z-50 overflow-hidden">
                        <SelectItem value="Starter" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">Starter</SelectItem>
                        <SelectItem value="Growth" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">Growth</SelectItem>
                        <SelectItem value="Premium" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">Premium</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">MOQ yang Direncanakan *</label>
                    <Select>
                      <SelectTrigger className="w-full border-gray-200 focus:ring-[#C19B6C] focus:border-[#C19B6C] h-[46px] bg-white text-sm">
                        <SelectValue placeholder="Pilih MOQ" />
                      </SelectTrigger>
                      <SelectContent className="bg-white border border-[#E8DCC8] shadow-2xl rounded-xl z-50 overflow-hidden">
                        <SelectItem value="1.000 pcs" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">1.000 pcs</SelectItem>
                        <SelectItem value="3.000 pcs" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">3.000 pcs</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Target Launching</label>
                    <Select>
                      <SelectTrigger className="w-full border-gray-200 focus:ring-[#C19B6C] focus:border-[#C19B6C] h-[46px] bg-white text-sm">
                        <SelectValue placeholder="Pilih Waktu" />
                      </SelectTrigger>
                      <SelectContent className="bg-white border border-[#E8DCC8] shadow-2xl rounded-xl z-50 overflow-hidden">
                        <SelectItem value="1-2 Bulan" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">1-2 Bulan</SelectItem>
                        <SelectItem value="3-4 Bulan" className="cursor-pointer py-2.5 px-3 rounded-lg font-medium transition-all hover:bg-[#F9F5EC] hover:text-[#C19B6C] focus:bg-[#F9F5EC] focus:text-[#C19B6C] text-[14px]">3-4 Bulan</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Pesan / Kebutuhan Khusus</label>
                  <textarea rows="4" className="w-full border border-gray-200 rounded p-3 text-sm focus:ring-[#C19B6C] focus:border-[#C19B6C]" placeholder="Ceritakan detail kebutuhan produk Anda..."></textarea>
                </div>
                <button type="button" className="w-full bg-[#C19B6C] hover:bg-[#A8865A] text-white py-3 rounded font-semibold transition-colors mt-4">
                  Kirim Permintaan Proposal
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-16 bg-white border-t border-gray-100">
        <div className="container mx-auto px-6 lg:px-12 max-w-4xl">
          <div className="text-center mb-10">
            <span className="text-[#C19B6C] font-bold tracking-wider text-sm mb-2 block uppercase">FAQ</span>
            <h2 className="text-3xl font-extrabold">Pertanyaan yang Sering Diajukan</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
            {faqs.map((faq, idx) => (
              <div key={idx} className="border border-gray-200 rounded-lg overflow-hidden h-max">
                <button 
                  onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                  className="w-full flex items-center justify-between p-4 text-left bg-white hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-sm">{faq.q}</span>
                  {openFaq === idx ? <Minus className="w-4 h-4 text-[#C19B6C] flex-shrink-0" /> : <Plus className="w-4 h-4 text-[#C19B6C] flex-shrink-0" />}
                </button>
                {openFaq === idx && (
                  <div className="p-4 pt-0 text-sm text-gray-600 bg-white">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="py-16 bg-[#FDFBF7]">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="bg-[#F3EFEA] rounded-2xl overflow-hidden flex flex-col md:flex-row items-center">
            <div className="p-10 lg:p-16 md:w-1/2">
              <h2 className="text-3xl lg:text-4xl font-extrabold mb-6 leading-tight">Siap Membangun Brand Skincare Anda?</h2>
              <p className="text-gray-600 mb-8">
                Mulai perjalanan brand Anda bersama tim ahli yang berpengalaman dalam formulasi skincare, uji stabilitas, dan pengembangan produk.
              </p>
              <button className="bg-[#C19B6C] hover:bg-[#A8865A] text-white px-8 py-3 rounded font-semibold transition-colors">
                Konsultasi Gratis <ArrowRight className="w-4 h-4 inline ml-2" />
              </button>
            </div>
            <div className="md:w-1/2 h-full">
              <img src="/placeholder-cta.jpg" alt="Skincare" className="w-full h-full object-cover min-h-[300px]" onError={(e) => e.target.src = 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?q=80&w=800&auto=format&fit=crop'} />
            </div>
          </div>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
}
